exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.c-grid-header[data-v-2723f26e] {\n  display: none;\n}\n", ""]);

// exports
